// import React, { createContext, useState, useContext, useEffect } from "react";

// // Create Context
// const YearContext = createContext();

// // Provider Component
// export const YearProvider = ({ children }) => {
//   const [yearSelected, setYearSelected] = useState("2025");

//   useEffect(() => {
//     // Check if there's a stored year in localStorage
//     const storedYear = localStorage.getItem("yearSelected");

//     if (!storedYear) {
//       // If no year in localStorage, set the default year to '2024'
//       localStorage.setItem("yearSelected", "2025");
//       setYearSelected("2025"); // Default year
//     } else {
//       // If year is in localStorage, set it
//       setYearSelected(storedYear);
//     }
//   }, []);

//   const onYearChange = (newYear) => {
//     setYearSelected(newYear);
//     localStorage.setItem("yearSelected", newYear);
//   };

//   // Function to clear year from localStorage (can be called on logout)
//   const clearYearFromLocalStorage = () => {
//     localStorage.removeItem("yearSelected");
//     setYearSelected("2025"); // Reset to default 2025 on logout
//   };

//   return (
//     <YearContext.Provider
//       value={{ yearSelected, onYearChange, clearYearFromLocalStorage }}
//     >
//       {children}
//     </YearContext.Provider>
//   );
// };

// // Custom Hook to use Year Context
// export const useYearContext = () => {
//   return useContext(YearContext);
// };



/// version-1 with auto-compute of tax year of no year in localStorage and fincancial year generation is not included
// import React, { createContext, useState, useContext, useEffect } from "react";

// const YearContext = createContext();

// export const YearProvider = ({ children }) => {
//   const [yearSelected, setYearSelected] = useState("");

//   // Function to compute tax year based on today's date
//   const computeTaxYear = () => {
//     const today = new Date();
//     const currentYear = today.getFullYear();

//     // Cutoff date = 30 Nov of current year
//     const cutoff = new Date(currentYear, 10, 30); // Month 10 = November

//     // If today is BEFORE 30 Nov → tax year is previous year
//     // If today is ON or AFTER 30 Nov → tax year is current year
//     return today < cutoff ? currentYear - 1 : currentYear;
//   };

//   useEffect(() => {
//     // Get stored year if any
//     const storedYear = localStorage.getItem("yearSelected");

//     const currentTaxYear = computeTaxYear(); // Compute based on real date

//     if (!storedYear) {
//       // If nothing stored → set current tax year
//       localStorage.setItem("yearSelected", currentTaxYear.toString());
//       setYearSelected(currentTaxYear.toString());
//     } else {
//       // If stored year is old or incorrect, auto-correct it
//       if (parseInt(storedYear) !== currentTaxYear) {
//         localStorage.setItem("yearSelected", currentTaxYear.toString());
//         setYearSelected(currentTaxYear.toString());
//       } else {
//         setYearSelected(storedYear);
//       }
//     }
//   }, []);

//   const onYearChange = (newYear) => {
//     setYearSelected(newYear);
//     localStorage.setItem("yearSelected", newYear);
//   };

//   const clearYearFromLocalStorage = () => {
//     localStorage.removeItem("yearSelected");
//     const currentTaxYear = computeTaxYear();
//     setYearSelected(currentTaxYear.toString());
//   };

//   return (
//     <YearContext.Provider
//       value={{ yearSelected, onYearChange, clearYearFromLocalStorage }}
//     >
//       {children}
//     </YearContext.Provider>
//   );
// };

// export const useYearContext = () => useContext(YearContext);



// /// version-2 with auto-compute of tax year and financial year generation
// import React, { createContext, useContext, useState, useEffect } from "react";

// const YearContext = createContext();

// export const YearProvider = ({ children }) => {
//   const [yearSelected, setYearSelected] = useState("");

//   const getFinancialYear = () => {
//     const today = new Date();
//     const year = today.getFullYear();
//     const nov30 = new Date(year, 10, 30); // 10 = November

//     return today < nov30 ? year - 1 : year;
//   };

//   const generateFinancialYears = () => {
//     const currentFY = getFinancialYear();
//     const years = [];

//     for (let i = 0; i < 10; i++) {
//       years.push(currentFY - i);
//     }

//     return years;
//   };

//   useEffect(() => {
//     const savedYear = localStorage.getItem("selectedYear");
//     if (savedYear) {
//       setYearSelected(savedYear);
//     } else {
//       const fy = getFinancialYear();
//       setYearSelected(fy.toString());
//       localStorage.setItem("selectedYear", fy.toString());
//     }
//   }, []);

//   const onYearChange = (year) => {
//     setYearSelected(year);
//     localStorage.setItem("selectedYear", year);
//   };


//   const clearYearFromLocalStorage = () => {
//     localStorage.removeItem("selectedYear");
//     setYearSelected(""); // optional reset
//   };



//   return (
//     <YearContext.Provider
//       value={{
//         yearSelected,
//         onYearChange,
//         generateFinancialYears,
//         clearYearFromLocalStorage, // <--- added
//       }}
//     >
//       {children}
//     </YearContext.Provider>
//   );
// };

// export const useYearContext = () => useContext(YearContext);
// -----------------------------------------------
// OLD VERSION (Kept in comment as per requirement)
// -----------------------------------------------

// -------------------------------------------------------
// NEW + FINAL MERGED VERSION (THIS IS THE ACTIVE VERSION)
// -------------------------------------------------------

// import React, { createContext, useContext, useState, useEffect } from "react";

// const YearContext = createContext();

// export const YearProvider = ({ children }) => {
//   const [yearSelected, setYearSelected] = useState("");

//   // ✔ Financial Year Logic (Nov 30 Cutoff)
//   const getFinancialYear = () => {
//     const today = new Date();
//     const currentYear = today.getFullYear();
//     const cutoff = new Date(currentYear, 10, 30); // Nov 30
//     return today < cutoff ? currentYear - 1 : currentYear;
//   };

//   // ✔ Generate 10 years (current FY → previous 9 FY)
//   const generateFinancialYears = () => {
//     const currentFY = getFinancialYear();
//     return Array.from({ length: 10 }, (_, i) => currentFY - i);
//   };

//   // ✔ Load saved year OR auto-set current FY
//   useEffect(() => {
//     const storedYear = localStorage.getItem("selectedYear");
//     if (storedYear) {
//       setYearSelected(storedYear);
//     } else {
//       const fy = getFinancialYear();
//       setYearSelected(fy.toString());
//       localStorage.setItem("selectedYear", fy.toString());
//     }
//   }, []);

//   // ✔ Change year
//   const onYearChange = (year) => {
//     setYearSelected(year);
//     localStorage.setItem("selectedYear", year);
//   };

//   // ✔ Optional reset
//   const clearYearFromLocalStorage = () => {
//     localStorage.removeItem("selectedYear");
//     setYearSelected("");
//   };

//   return (
//     <YearContext.Provider
//       value={{ yearSelected,
//         onYearChange,
//         generateFinancialYears,
//         clearYearFromLocalStorage,
//       }}
//     >
//       {children}
//     </YearContext.Provider>
//   );
// };

// export const useYearContext = () => useContext(YearContext);


import React, { createContext, useContext, useState, useEffect } from "react";

const YearContext = createContext();

export const YearProvider = ({ children }) => {
  const [yearSelected, setYearSelected] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);

  const getFinancialYear = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const cutoff = new Date(currentYear, 10, 30); // Nov 30 (month is 0-indexed)
    return today < cutoff ? currentYear - 1 : currentYear;
  };

  const generateFinancialYears = () => {
    const currentFY = getFinancialYear();
    return Array.from({ length: 10 }, (_, i) => currentFY - i);
  };

  // Initialize year on component mount
  useEffect(() => {
    const initializeYear = () => {
      const storedYear = localStorage.getItem("selectedYear");
      const currentFY = getFinancialYear().toString();
      
      if (storedYear) {
        setYearSelected(storedYear);
      } else {
        setYearSelected(currentFY);
        localStorage.setItem("selectedYear", currentFY);
      }
      
      setIsInitialized(true);
    };

    initializeYear();
  }, []);

  const onYearChange = (year) => {
    setYearSelected(year);
    localStorage.setItem("selectedYear", year);
  };

  const clearYearFromLocalStorage = () => {
    localStorage.removeItem("selectedYear");
    const currentFY = getFinancialYear().toString();
    setYearSelected(currentFY);
  };

  return (
    <YearContext.Provider
      value={{
        yearSelected,
        onYearChange,
        generateFinancialYears,
        clearYearFromLocalStorage,
        isInitialized // Add this to track initialization
      }}
    >
      {children}
    </YearContext.Provider>
  );
};

export const useYearContext = () => {
  const context = useContext(YearContext);
  if (!context) {
    throw new Error("useYearContext must be used within a YearProvider");
  }
  return context;
};